// Simple cart count & header behavior
document.addEventListener('DOMContentLoaded', function () {
  const cartToggle = document.getElementById('CartToggle');
  if (cartToggle) {
    cartToggle.addEventListener('click', function () {
      window.location.href = '/cart';
    });
  }
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      document.querySelectorAll('[data-cart-count]').forEach(e => e.textContent = cart.item_count || 0);
    }).catch(()=>{});
});


// --- CART DRAWER & AJAX ADD ---
(function(){
  function qs(sel){return document.querySelector(sel)}
  function qsa(sel){return Array.from(document.querySelectorAll(sel))}
  const cartToggle = document.getElementById('CartToggle');
  const cartDrawer = qs('#CartDrawer');
  const drawerCloseEls = qsa('[data-drawer-close]');
  const drawerContents = qs('[data-drawer-contents]');
  const cartItemsList = qs('[data-cart-items-list]');
  const cartItemsWrap = qs('[data-cart-items]');
  const cartEmpty = qs('[data-cart-empty]');
  const cartSubtotal = qs('[data-cart-subtotal]');

  function openDrawer(){
    if(!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden','false');
    cartDrawer.classList.add('open');
    fetchCartAndRender();
  }
  function closeDrawer(){
    if(!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden','true');
    cartDrawer.classList.remove('open');
  }

  if(cartToggle){ cartToggle.addEventListener('click', function(e){ e.preventDefault(); openDrawer(); }); }
  drawerCloseEls.forEach(el=>el.addEventListener('click', closeDrawer));

  // Fetch cart and render drawer contents
  function fetchCartAndRender(){
    fetch('/cart.js').then(r=>r.json()).then(renderCart).catch(()=>{});
  }

  function renderCart(cart){
    if(!cart){ return; }
    const items = cart.items || [];
    if(items.length === 0){
      cartEmpty.style.display = '';
      cartItemsWrap.hidden = true;
      cartSubtotal.textContent = '';
    } else {
      cartEmpty.style.display = 'none';
      cartItemsWrap.hidden = false;
      cartItemsList.innerHTML = '';
      items.forEach(item=>{
        const li = document.createElement('li');
        li.className = 'cart-item';
        li.innerHTML = `
          <img src="${item.image || '/assets/logo.png'}" alt="${item.product_title}">
          <div>
            <div class="cart-item__title">${item.product_title}</div>
            <div class="muted">${item.variant_title || ''}</div>
          </div>
          <div style="text-align:right;">
            <div><input class="cart-item__qty" data-line="${item.key}" type="number" min="0" value="${item.quantity}" style="width:56px"></div>
            <div style="margin-top:.25rem">${(item.line_price/100).toFixed(2)}</div>
          </div>
        `;
        cartItemsList.appendChild(li);
      });
      cartSubtotal.textContent = (cart.items_subtotal_price/100).toFixed(2);
      // Attach change handlers to qty inputs
      qsa('.cart-item__qty').forEach(inp=>{
        inp.addEventListener('change', function(){
          const qty = parseInt(this.value,10);
          const line = this.getAttribute('data-line');
          updateCartLine(line, qty);
        });
      });
    }
    // Update header cart count
    qsa('[data-cart-count]').forEach(e=> e.textContent = cart.item_count || 0);
  }

  function updateCartLine(key, qty){
    // Shopify expects updates by line index; here we map keys to line numbers by /cart.js fetch
    fetch('/cart.js').then(r=>r.json()).then(function(cart){
      const idx = cart.items.findIndex(i=>i.key===key);
      if(idx===-1) return;
      const updates = {};
      updates[idx+1] = qty; // lines are 1-indexed in /cart/update.js? Using alternative endpoint below
      // Use /cart/change to update by line
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({line: idx+1, quantity: qty})
      }).then(()=>fetchCartAndRender());
    });
  }

  // AJAX add to cart handler - intercept forms that post to /cart/add
  document.addEventListener('submit', function(e){
    const form = e.target;
    if(form && form.action && form.action.indexOf('/cart/add')!==-1){
      e.preventDefault();
      const data = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: data })
        .then(res=>res.json())
        .then(item=>{
          openDrawer();
        }).catch(()=>{ openDrawer(); });
    }
  });

  // Initialize - ensure drawer close when clicking backdrop
  if(qs('.cart-drawer__backdrop')){
    qs('.cart-drawer__backdrop').addEventListener('click', closeDrawer);
  }
})();

// --- DEMO PRODUCTS RENDER (for preview only) ---
(function(){
  // find product-grid on homepage and populate from assets/demo-products.json
  if(!document.querySelector('.product-grid')) return;
  fetch('/assets/demo-products.json').then(r=>r.json()).then(function(data){
    const grid = document.querySelector('.product-grid');
    grid.innerHTML = '';
    data.products.forEach(p=>{
      const a = document.createElement('a');
      a.href = p.url || '#';
      a.className = 'product-card';
      a.innerHTML = `
        <img src="${p.image}" alt="${p.title}" class="product-card__image">
        <div class="product-card__info">
          <h3 class="product-card__title">${p.title}</h3>
          <div class="product-card__price">${p.price}</div>
        </div>
      `;
      grid.appendChild(a);
    });
  }).catch(()=>{});
})();
